module.exports = __webpack_public_path__ + "static/img/contact_logo2_h.ede381e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo2_h.png
// module id = aTDc
// module chunks = 1